import React, { Component } from 'react';
import { strings } from 'APP_ROOT/localization';
import Analytics from 'APP_ROOT/services/analytics';

export default class MediaPage extends Component {

    constructor(props) {

        super(props);
    }

    componentDidMount() {
        Analytics.pageView();
    }

    render() {

        return (
            <div id="mediaPage" className="container media-page">
                <div className="container">
                    <div className="row">
                        <div className="col-12"><h1>{strings.media_page_title}</h1></div>
                    </div>
                </div>
            </div>
        );
    }
}
